import { Component, OnInit, ViewChild } from '@angular/core';
import { HeaderData } from 'src/app/_models/header-data';
import { DiceService } from '../_services/dice.service';
import { Router } from '@angular/router';
import { RESULTS_NOT_FOUND } from 'src/app/_common/product-config';
import { UserRole, StatusCode, QuoteStatus, AccountStatus, LobStatus, DiceQuoteTypes } from 'src/app/_common/_enum/module.enum';

@Component({
  selector: 'app-view-quotes-list',
  templateUrl: './view-quotes-list.component.html',
  styleUrls: ['./view-quotes-list.component.scss']
})
export class ViewQuotesListComponent implements OnInit {
  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;
  private superUser: string;
  private enumSuperUser = UserRole.SuperUser;
  private enumSuperAdmin = UserRole.SuperAdmin;
  private selectedUser: string; //used on html view
  private userOktaId: string;

  public resultsNotFound: any = RESULTS_NOT_FOUND;
  public selectedItem: string = 'openquotes';

  private userList: any = null;
  private quotesList: any = null;
  private loading: boolean = false;
  private userListLoading: boolean = false;
  private downloadingDocument: any = [];
  private openQuoteList: any = [];
  private closedQuoteList: any = [];
  private issuedQuoteList: any = [];
  private accountStatuses: any = AccountStatus;
  private quoteStatuses: any = QuoteStatus; //used on html view
  private lobStatuses: any = LobStatus;  //used on html view
  private viewMoreQuotes: boolean = false; //used on html view
  private issuedLobs: any = [];
  private issuedAccount;
  private isDocReady: boolean = true;
  private hasAccess:boolean = false;

  /**** Child View for All Modals ****/
  @ViewChild("policyDocumentsModal", {static: false}) policyDocumentsModal;

  constructor(private diceService: DiceService, private router: Router) { }

  ngOnInit() {
    let storageData = this.diceService.getStorageData();
    this.userOktaId = storageData.currentUser.UID;
    this.superUser = storageData.currentUser.userRole;

    this.selectedUser = storageData.currentUser.firstName + " " + storageData.currentUser.lastName;
    console.log("this.selectedUser :: " , this.selectedUser);

    //this.fetchUserList();
    if(this.superUser === this.enumSuperUser || this.superUser === this.enumSuperAdmin){ 
      this.fetchUserList();
    }
    
    this.fetchQuoteList(null);
  }

  setHeaderData(details?: any){
    this.headerData.pageTitle = "Dice Quotes";

    this.diceService.header = this.headerData;  
  }

  gotoQuoteDetails(appKey: string, quoteId: string) {
    //this.router.navigate(['/dice/quote'],{ key: appKey, id: quoteId } );

    //this.router.navigate(['search', term]);
  }

  fetchUserList() {
    this.userListLoading = true;

    let userListSubscription = this.diceService.fetchUserList().subscribe(response => {
      this.userListLoading = false;
      this.userList = response;
      //console.log('this.userList', this.userList);
    },error=>{
        this.userListLoading = false;
    });

    this.diceService.runningServices.push(userListSubscription);
  }

  fetchQuoteList(_oktaId) {
    console.log("In fetch quote :: ", _oktaId);
    this.loading = true;
    
    let quoteListSubscription = this.diceService.fetchQuoteList(_oktaId).subscribe(response => {
      this.loading = false;
      this.hasAccess = true;
      this.quotesList = response;

      let tempOpenQuoteList: any = [];
      let tempClosedQuoteList: any = [];
      let tempIssuedQuoteList: any = [];

      console.log('QuoteList :: ', this.quotesList);

      this.quotesList.forEach(account => {
        if(account.accountStatus === this.accountStatuses.Available || account.accountStatus === this.accountStatuses.Referred) {
          tempOpenQuoteList.push(account);
        } else if (account.accountStatus === this.accountStatuses.NotAvailable) {
          tempClosedQuoteList.push(account)
        } else {
          tempIssuedQuoteList.push(account)
        }
      });
      this.openQuoteList = tempOpenQuoteList;
      this.closedQuoteList = tempClosedQuoteList;
      this.issuedQuoteList = tempIssuedQuoteList;

      console.log('this.openList', this.openQuoteList);
      console.log('this.closeList', this.closedQuoteList);
      console.log('this.issuedList', this.issuedQuoteList);
    },error=>{
        this.loading = false;
        this.hasAccess = !(error.status == StatusCode.NoAccess);
    });

    this.diceService.runningServices.push(quoteListSubscription);
  }

  viewPolicyDocumentsModal(account) {
    this.issuedAccount = account;

    this.diceService.openModal('none', this.policyDocumentsModal, true, 'light-blue-backdrop', 'static', 'documentsListModal');
  }

  downloadPolicyDocument(_lob, accNo, idx) {
    let documentDts = {
      accountNumber: accNo,
      policyNumber: _lob.policyNumber
    }

    console.log('documentDts :: ', documentDts);

    this.downloadingDocument[idx] = true;

    this.diceService.downloadDocuments(_lob.lobType, documentDts).subscribe(data => {
      this.downloadingDocument[idx] = false;
      console.log("data : ", data);

      /*** If the policy document is not available it will display message on modal ***/
      if(data){
        _lob.docsAvailable = true;
        this.diceService.closeModal();
      }
      else {
        _lob.docsAvailable = false;
      }

      console.log("_lob.docsAvailable :: ", _lob.docsAvailable);
    },
    error => {
      console.log("Clear Account Failed");
      this.downloadingDocument[idx] = false;

      let hasOpenModals = this.diceService.hasOpenModals();
      if (hasOpenModals) {
        this.diceService.closeModal();
      }
      
      if(error.status == StatusCode.InternalServer) {
        setTimeout(() => {
          this.diceService.openModal('error', 'none', false, 'light-blue-backdrop', false, '');
        }, 50);
      }
      console.warn("Download Policy Documents Failed!!  : " + error);
    });
  }

  gotoUrl(_url, appKey, quoteId) {
    this.router.navigateByUrl("newbusiness/dice/"+ _url + "/" + appKey + "/" + quoteId);
  }

  /* gotoURL(url) {
    this.router.navigateByUrl(url);
  } */

  copyQuote(_appId, _quoteId) {
    let _quoteDetails = {
      diceQuoteType: DiceQuoteTypes.Copy,
      applicationId: _appId,
      quoteId: _quoteId
    };
    console.log('_quoteDetails - listscreen :: ', _quoteDetails);
    this.router.navigate(["newbusiness/dice/create"], {state: {diceQuoteDetails: _quoteDetails}});
  }

  ngOnDestroy() {
    this.diceService.runningServices.forEach(subscription => subscription.unsubscribe());
  }
}